/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechCamVideoIcon16Light } from './TechCamVideoIcon16Light';
import { TechCamVideoIcon16Regular } from './TechCamVideoIcon16Regular';
import { TechCamVideoIcon16Solid } from './TechCamVideoIcon16Solid';
import { TechCamVideoIcon20Light } from './TechCamVideoIcon20Light';
import { TechCamVideoIcon20Regular } from './TechCamVideoIcon20Regular';
import { TechCamVideoIcon20Solid } from './TechCamVideoIcon20Solid';
import { TechCamVideoIcon24Regular } from './TechCamVideoIcon24Regular';
import { TechCamVideoIcon24Solid } from './TechCamVideoIcon24Solid';
import { TechCamVideoIcon32Regular } from './TechCamVideoIcon32Regular';
import { TechCamVideoIcon64Regular } from './TechCamVideoIcon64Regular';
var sizes = {
    16: {
        light: TechCamVideoIcon16Light,
        regular: TechCamVideoIcon16Regular,
        solid: TechCamVideoIcon16Solid,
    },
    20: {
        light: TechCamVideoIcon20Light,
        regular: TechCamVideoIcon20Regular,
        solid: TechCamVideoIcon20Solid,
    },
    24: {
        regular: TechCamVideoIcon24Regular,
        solid: TechCamVideoIcon24Solid,
    },
    32: {
        regular: TechCamVideoIcon32Regular,
    },
    64: {
        regular: TechCamVideoIcon64Regular,
    },
};
export var TechCamVideoIcon = forwardRef('TechCamVideoIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
